(function ($) {
  threeStepRowV1 = {
    formatter: $('.three-step-row-v1')
  };

  Drupal.behaviors.threeStepRowV1 = {
    get: function (key) {
      return threeStepRowV1[key];
    },

    set: function (key, val) {
      threeStepRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // quickview slide down
        thisFormatter.find('.btn-quickview').once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();
          $('#quickshop .close').trigger('click');
          var prodId = $(this).closest('.product').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = $(page_data['product-input-type'].products).filter(function () {
              return this.PRODUCT_ID === prodId;
            })[0];
            var $qs = site.quickshop.render({
              productData: product
            });
            var clickedProduct = $(this).closest('.product');
            var bottom_padding = 50;
            var speed = 500;
            var topPositionNavOffset = $('#top').height() + 40;

            // append after row
            $qs.insertAfter($(this).parents('.row')).delay(100).slideDown(speed, function () {
              var pos = $qs.position();
              var window_height = $(window).height();
              var offset = $qs.offset();
              var posY = offset.top - $(window).scrollTop();
              var clickedProductOffset = clickedProduct.offset();
              var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
              var qs_bottom_position = posY + $('#quickshop').height() + bottom_padding;

              // only scroll page if the quickshop fall within the viewable area
              if (qs_bottom_position > window_height) {
              /**
               * bottom of quickshop isn't visible, so let's formulate both options
              **/
                // option 1: place selected product near top of viewing area
                var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
                // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
                var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
                // select our best option
                var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

                // now scroll the window...
                $('body, html').scrollTo(scrollPosition, {
                  duration: speed,
                  axis: 'y'
                });
              }
            });
            // override close to remove dom node
            $qs.find('.close').off('click').on('click', function() {
              $qs.slideUp('500', function () {
                $qs.remove();
                $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').addClass('hidden');
              });
            });
            // show caret
            $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').removeClass('hidden');
          }
        });
        thisFormatter.find('.button.cta').addClass('pc');
      });

      $('.button.cta.pc', context).on('click', function(e) {
        e.preventDefault();
        var buySkus = [];
        var container = $($(e.target).parents('.row').get(0));
        var manualIds = container.attr('data-allskuids');

        if (manualIds) {
        // if the container has a list of manually added, preferred skuids, use those
          var skuIds = manualIds.split(/ *, */);

          buySkus = $.map(skuIds, function (el) {
            return el.replace(/SKU/, '');
          });
        } else {
        // else iterate through each product div to get sku for 'add all to cart'
          container.find('div[data-productid]').each(function () {
            buySkus.push(Drupal.behaviors.ctaButton.actions.getSkuId($(this)));
          });
        }
        var loadingId = site.loading.show({
          'target': e.target,
          'matchTarget': ['display', 'height', 'width'],
          'css': {
            'text-align': 'center',
            'vertical-align': 'bottom',
            'margin-bottom': '-79px'
          }
        });

        // add sku array to cart
        site.addToCart({
          skuBaseId: buySkus
        });
        $(document).one('addToCart.success addToCart.failure', function () {
          site.loading.hide(loadingId);
        });
      });
    }
  };
})(jQuery);
